import { render, staticRenderFns } from "./ContractBoxFondanteile.vue?vue&type=template&id=7538bf91&scoped=true&v-if=showSomething&"
import script from "./ContractBoxFondanteile.vue?vue&type=script&lang=ts&"
export * from "./ContractBoxFondanteile.vue?vue&type=script&lang=ts&"
import style0 from "./ContractBoxFondanteile.vue?vue&type=style&index=0&id=7538bf91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7538bf91",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VCol,VDataTable,VDivider,VIcon,VRow})
